import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../redux/configureStore";
import LinearAudioLevelIndicator from "./LinearAudioLevelIndicator";
import {
  getSelectedAudioSource,
  getSelectedVideoSource,
} from "../../app/selectors";
import LogError from "../../logging/LogError";

const PublisherPreview = () => {
  const preview = useRef<OT.Publisher>();
  const [audioLevel, setAudioLevel] = useState(0);
  const selectedVideoSource = useAppSelector(getSelectedVideoSource);
  const selectedAudioSource = useAppSelector(getSelectedAudioSource);

  useEffect(() => {
    if (selectedVideoSource && preview.current === undefined) {
      const options: OT.PublisherProperties = {
        insertMode: "replace",
        style: { buttonDisplayMode: "off" },
        width: "100%",
        height: "100%",
        fitMode: "contain",
        publishVideo: true,
        publishAudio: true,
        resolution: "1280x960",
        echoCancellation: true,
        mirror: false,
        disableAudioProcessing: true,
        videoSource: selectedVideoSource.deviceId,
        audioSource: selectedAudioSource?.deviceId,
      };
      preview.current = OT.initPublisher("preview", options, (error) => {
        if (error) {
          LogError(error);
        }
      });

      preview.current.on("audioLevelUpdated", (event) => {
        setAudioLevel(event.audioLevel);
      });
    }
  }, [selectedAudioSource?.deviceId, selectedVideoSource]);

  useEffect(
    () => () => {
      preview?.current?.destroy();
    },
    [],
  );

  useEffect(() => {
    if (selectedVideoSource) {
      preview.current?.setVideoSource(selectedVideoSource.deviceId);
    }
    if (selectedAudioSource) {
      preview.current?.setAudioSource(selectedAudioSource.deviceId);
    }
  }, [selectedAudioSource, selectedVideoSource]);

  return (
    <div className="container">
      <div id="preview" />
      <div className="overlay">
        <LinearAudioLevelIndicator volume={audioLevel} />
      </div>
      <style jsx>{`
        .container {
          position: relative;
          width: 100%;
          height: 100%;
        }
        #preview {
          position: absolute;
          height: 100%;
          width: 100%;
          border-radius: 6px;
          background-color: black;
        }
        .overlay {
          position: absolute;
          right: 10px;
          bottom: 5px;
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
        }
      `}</style>
    </div>
  );
};

export default PublisherPreview;
